import { render, staticRenderFns } from "./amount_display.vue?vue&type=template&id=2e4df198&"
import script from "./amount_display.vue?vue&type=script&lang=js&"
export * from "./amount_display.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports